import React from 'react'
import { ListQuestion as ListQuestionType } from '../../../../types/end-journey'

interface ListQuestionProps {
  question: ListQuestionType
}

export const ListQuestion: React.FC<ListQuestionProps> = ({ question }) => {
  const contentLines = question.options?.map((option) => option.label) || []

  return (
    <div className="w-full max-w-2xl mx-auto px-6 pt-16 pb-2">
      <div className="space-y-6">
        <div className="space-y-2">
          <h2 className="text-xl font-semibold text-gray-900">
            {question.title}
          </h2>
          <p className="text-gray-600">{question.description}</p>
        </div>
        <div className="border border-gray-200 rounded-lg divide-y divide-gray-200">
          {contentLines.map((line, index) => (
            <div key={index} className="p-4">
              <span className="text-gray-900">{line}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
